/**
 * Relative time for a timestamp, handling BOTH past ("5m ago") and future
 * ("in 4d"). Returns null for a missing/invalid input so callers can omit it.
 *
 * FRONT-556: the cron detail page kept its own past-only copy that computed
 * `now - timestamp` and bucketed any negative (future) diff into "<1m ago" —
 * so a cron's next run, days away, displayed as "<1m ago" while the schedule
 * list (which had this future-aware version) showed "in 4d". This is now the
 * single shared formatter so the two views can't disagree again.
 */
export function formatRelativeTime(iso?: string | null): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  const diff = Date.now() - d.getTime();

  if (diff < 0) {
    const future = -diff;
    if (future < 60_000) return 'in <1m';
    if (future < 3_600_000) return `in ${Math.round(future / 60_000)}m`;
    if (future < 86_400_000) return `in ${Math.round(future / 3_600_000)}h`;
    return `in ${Math.round(future / 86_400_000)}d`;
  }
  if (diff < 60_000) return '<1m ago';
  if (diff < 3_600_000) return `${Math.round(diff / 60_000)}m ago`;
  if (diff < 86_400_000) return `${Math.round(diff / 3_600_000)}h ago`;
  return `${Math.round(diff / 86_400_000)}d ago`;
}
